import { ImageData } from '@interfaces/image'

const formatImage = (
  image: ImageData | undefined,
  format: 'thumbnail' | 'small' | 'medium' | 'large'
) => {
  if (image?.formats[format]?.url) {
    return `${process.env.NEXT_PUBLIC_IMAGE_PREFIX || ''}${
      image.formats[format].url
    }`
  }
  if (image?.url) {
    return `${process.env.NEXT_PUBLIC_IMAGE_PREFIX || ''}${image.url}`
  }

  return '/images/photos/blur.png'
}

interface BlurImage {
  placeholder: string
}

const formatBlurImage = (image: BlurImage | undefined) => {
  if (image?.placeholder) {
    return `${image.placeholder}`
  }

  return '/images/photos/blur.png'
}

export { formatImage, formatBlurImage }
